// Fotorecenze - inicializace po načtení Satisflow widgetu
$(document).ready(function () {
    var sfCheckInterval = null;
    var sfObserver = null;

    function tryInit() {
        var $widget = $("[data-sf-id='Doplnek Fotorecenze www.satisflow.cz']");
        if ($widget.length && $widget.find(".flickity-enabled").length && $widget.find(".sf-review").length > 0 && !$widget.hasClass("sf-styled")) {
            $widget.addClass("sf-styled");
            if (sfObserver) sfObserver.disconnect();
            if (sfCheckInterval) clearInterval(sfCheckInterval);
            // Malý delay pro stabilitu Flickity
            setTimeout(function () {
                initPhotoReviews($widget);
            }, 300);
            return true;
        }
        return false;
    }

    // Zkus rovnou
    if (!tryInit()) {
        // MutationObserver jako hlavní detekce
        sfObserver = new MutationObserver(function () {
            tryInit();
        });
        sfObserver.observe(document.body, { childList: true, subtree: true });

        // Fallback polling
        sfCheckInterval = setInterval(function () {
            tryInit();
        }, 500);

        // Timeout po 15s
        setTimeout(function () {
            if (sfObserver) sfObserver.disconnect();
            if (sfCheckInterval) clearInterval(sfCheckInterval);
        }, 15000);
    }

    function initPhotoReviews($widget) {
        // Změna nadpisu
        var $headline = $widget.find("#sf-reviews-widget-headline");
        $headline.html("Fotorecenze našich zákazníků");

        // Header wrapper s navigací
        $headline.wrap("<div class='sf-header'></div>");

        var $navi = $("<div class='sf-navi'>" +
            "<button class='sf-navi__btn sf-navi__btn--prev' aria-label='Předchozí'></button>" +
            "<button class='sf-navi__btn sf-navi__btn--next' aria-label='Další'></button>" +
        "</div>");
        $headline.after($navi);

        // Skrytí originálních Flickity tlačítek
        $widget.find(".flickity-prev-next-button").css("display", "none");

        // Napojení šipek na originální Flickity tlačítka
        var $prevBtn = $widget.find(".flickity-prev-next-button.previous");
        var $nextBtn = $widget.find(".flickity-prev-next-button.next");

        $navi.find(".sf-navi__btn--prev").on("click", function () {
            if ($prevBtn.length) $prevBtn[0].click();
        });
        $navi.find(".sf-navi__btn--next").on("click", function () {
            if ($nextBtn.length) $nextBtn[0].click();
        });

        // Změna textu tlačítek "Přejít na produkt" → "Ukázat produkt"
        $widget.find(".satisflow-reviewed-product-link a").text("Ukázat produkt");

        // Skrytí navigačních šipek, pokud není kam scrollovat
        function toggleNavi() {
            var $flickity = $widget.find(".flickity-enabled");
            var viewportW = $flickity.find(".flickity-viewport").outerWidth();
            var totalW = 0;
            $widget.find(".sf-review").each(function () {
                totalW += $(this).outerWidth(true);
            });
            $navi.toggle(totalW > viewportW);
        }

        $(window).on("resize", toggleNavi);

        // Resize Flickity, přesun na první slide a zamknutí výšky
        setTimeout(function () {
            var flktyEl = $widget.find("#sf-reviews-widget")[0] || $widget.find(".flickity-enabled")[0];
            var flkty = (typeof Flickity !== "undefined" && flktyEl) ? Flickity.data(flktyEl) : null;

            if (flkty) {
                // Zarovnání doleva (Satisflow default je center) + vypnutí přepočtu výšky
                flkty.options.cellAlign = "left";
                flkty.options.setGallerySize = false;

                // Mobilní peek efekt — shodný s produktovým swiperem
                // margin-inline -10px = rozšíření karuselu přes container
                // spacer 10px = ekvivalent Swiper slidesOffsetBefore
                if ($(window).width() <= 767) {
                    $widget.find(".flickity-enabled")[0].style.setProperty("margin-inline", "-10px");

                    var spacer = document.createElement("div");
                    spacer.style.cssText = "width:10px;min-height:1px;pointer-events:none";
                    flkty.prepend(spacer);
                }

                flkty.resize();
                flkty.select(0, false, true);
            }

            // Nastavení CSS custom property pro výšku viewportu
            var $firstImg = $widget.find(".sf-review-img img").first();
            var imgH = $firstImg.length ? $firstImg[0].getBoundingClientRect().height : 335;
            var $firstName = $widget.find(".sf-review-name").first();
            var nameH = $firstName.length ? $firstName[0].getBoundingClientRect().height : 140;
            var totalH = imgH + nameH;

            if (totalH > 0) {
                $widget[0].style.setProperty("--sf-viewport-h", totalH + "px");
            }

            toggleNavi();
        }, 500);
    }
});
